import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortByField',
  standalone: true,
})
export class SortByFieldPipe implements PipeTransform {
  transform(array: any[], field: string): any[] {
    if (!Array.isArray(array) || !field) return array;

    return array
      .map((item, index) => ({
        ...item,
        [field]: item[field],
      }))
      .sort((a, b) => {
        const valueA = a[field];
        const valueB = b[field];
        return valueA - valueB;
      });
  }
}
